import { Component, input } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AppStateService } from "@services/index";

/**
 * Shared no-reload data-refresh button for every page's header/toolbar area.
 * Re-validates the session (via AppStateService.refreshCurrentView) before invoking the
 * page's own existing load method — on a dead session it hard-redirects to /login instead.
 */
@Component({
  selector: "fh-refresh-button",
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: "./refresh-button.component.html",
  styleUrls: ["./refresh-button.component.scss"],
})
export class RefreshButtonComponent {
  // The page's own existing data-loading method — refreshCurrentView() calls this after
  // re-validating the session, instead of duplicating any fetch logic here.
  onRefresh = input.required<() => void>();
  label = input<string>("Refresh");

  constructor(public appStateService: AppStateService) {}

  refresh(): void {
    this.appStateService.refreshCurrentView(this.onRefresh());
  }
}
